import { Combobox } from "@/components/ui/combobox";
import { ComboboxMulti } from "@/components/ui/combobox_mutli";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { useSearchParams } from "react-router-dom";

interface FilterBarProps {
  selectedYears: number[];
  setSelectedYears: (years: number[]) => void;
  selectedCustomerId: string | undefined;
  setSelectedCustomerId: (id: string | undefined) => void;
  selectedEmployeeId: string | undefined;
  setSelectedEmployeeId: (id: string | undefined) => void;
  yearOptions: { value: string; label: string }[];
  customers: Array<{ id: string; long_name: string }>;
  users: Array<{ id: string; name: string }>;
}

export function FilterBar({
  selectedYears,
  setSelectedYears,
  selectedCustomerId,
  setSelectedCustomerId,
  selectedEmployeeId,
  setSelectedEmployeeId,
  yearOptions,
  customers,
  users,
}: FilterBarProps) {
  const [searchParams, setSearchParams] = useSearchParams();

  const handleCreateRequest = () => {
    searchParams.set("create_request", "true");
    setSearchParams(searchParams);
  };

  return (
    <div className="flex items-center gap-3 justify-end w-full">
      <div className="flex items-center gap-3">
      <div className="min-w-[180px]">
        <ComboboxMulti
          placeholder="Select years..."
          value={selectedYears.map(String)}
          onValueChange={(values) => setSelectedYears(values.map(Number))}
          options={yearOptions}
          dwimOnChange
        />
      </div>
      <div className="min-w-[200px]">
        <Combobox
          placeholder="All customers..."
          value={selectedCustomerId || ""}
          onValueChange={(value) => setSelectedCustomerId(value || undefined)}
          options={[
            { value: "", label: "All Customers" },
            ...customers.map((c) => ({ value: c.id, label: c.long_name }))
          ]}
          dwimOnChange
          popoverClassName="min-w-[400px]"
        />
      </div>
      <div className="min-w-[200px]">
        <Combobox
          placeholder="All employees..."
          value={selectedEmployeeId || ""}
          onValueChange={(value) => setSelectedEmployeeId(value || undefined)}
          options={[
            { value: "", label: "All Employees" },
            ...users.map((u) => ({ value: u.id, label: u.name }))
          ]}
          dwimOnChange
          popoverClassName="min-w-[250px]"
        />
      </div>
    </div>
      <Button onClick={handleCreateRequest} size="sm">
        <Plus className="h-4 w-4 mr-1" />
        Create Request
      </Button>
    </div>
  );
}
